const getFormattedPhoneNumber = (phoneNumberStr) => {
  const cleaned = `${phoneNumberStr}`.replace(/\D/g, "");
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    const countryCode = match[1] ? "+1 " : "";
    return [countryCode, match[2], "-", match[3], "-", match[4]].join("");
  }

  return cleaned ?? null;
};

export default getFormattedPhoneNumber;
